import { useCallback, useMemo } from 'react'
import { WbsItemSelectOptions } from '../wbsItemSelectOptions'
import { WbsItemAdditionalPropertyLayoutEntity } from '../../../../../domain/entity/WbsItemAdditionalPropertyLayoutEntity'
import { useWbsItemChangeLogParser } from '../wbsItemChangeLogParser'
import { useTicketListRepository } from '../../../../../services/adaptors/ticketListRepositoryAdaptor'
import { useReferencedEntityParser } from '../changeLogParser'

export const useTicketChangeLogParser = (
  { subStatuses, difficulties, priorities }: WbsItemSelectOptions,
  wbsItemAdditionalProperties: WbsItemAdditionalPropertyLayoutEntity | undefined
) => {
  const { fetchAsReferencedEntity: fetchTicketList } = useTicketListRepository()
  const ticketListParser = useReferencedEntityParser(fetchTicketList)
  const getWbsItemChangeLogParser = useWbsItemChangeLogParser(
    { subStatuses, difficulties, priorities },
    wbsItemAdditionalProperties
  )
  const getChangeLogParser = useCallback(
    (path: string) => {
      switch (path) {
        case 'ticketListUuid':
          return ticketListParser
        default:
          return getWbsItemChangeLogParser(path)
      }
    },
    [ticketListParser, getWbsItemChangeLogParser]
  )
  return getChangeLogParser
}
